import { Checkbox, Grid, useBoolean } from '@chakra-ui/react';
import React from 'react';
import { useFormContext } from 'react-hook-form';

import { TypeUtils } from '../../../../framework/utils/UtilityTypes';
import { useFormItems } from '../../../hooks/formItems';
import { AssignWorkInfoDaySearchResult } from '../../../models/gen/assignWorkInfoDaySearchResult';
import { Formatter } from '../../../utils/FormatUtils';
import { GridItem } from './GridItem';
import { AssignWorkInfoProps } from './WorkReport';
type DailyWorkProps = AssignWorkInfoProps & {
  isOvertime: boolean;
  /**
   * 現場数
   */
  matterSize: number;
  totalWorkTime: number;
  workTimeFrom: string | null;
  workTimeTo: string | null;
  ATTENDANCE_TYPE_PRESENT?: number;
};

export const useDailyWork = () => {
  const [isAbsence, { toggle }] = useBoolean();

  const form = useFormContext<AssignWorkInfoDaySearchResult>();
  const { FormText } = useFormItems(form);

  /**
   * 日次就業エリア
   *
   * @returns
   */
  const DailyWork: React.FunctionComponent<DailyWorkProps> = ({
    isOvertime,
    matterSize,
    mode,
    totalWorkTime,
    workTimeFrom,
    workTimeTo,
    ATTENDANCE_TYPE_PRESENT,
  }) => {
    return (
      <Grid
        backgroundColor="white"
        borderColor="gray.300"
        borderRadius="md"
        borderWidth={1}
        padding={2}
        templateColumns="1fr 1fr"
        width="full"
      >
        <GridItem colSpan={2} hidden textAlign="left">
          <Checkbox
            isChecked={isAbsence}
            isDisabled={mode === 'view'}
            onChange={toggle}
          >
            欠勤
          </Checkbox>
        </GridItem>
        <GridItem>
          <FormText
            label="開始時刻"
            name="reference.dailyWork"
            value={() => Formatter.dateTimeOfWeekString(workTimeFrom, '―')}
          />
        </GridItem>
        <GridItem>
          <FormText
            label="終了時刻"
            name="reference.dailyWork"
            value={() => Formatter.dateTimeOfWeekString(workTimeTo, '―')}
          />
        </GridItem>
        <GridItem>
          <FormText
            label="休憩時間"
            name="reference.dailyWork"
            value={() => {
              const effectiveAttendanceTypeIndexes = form
                .getValues(
                  Array(matterSize)
                    .fill(null)
                    .map(
                      (_, index) =>
                        `results.${index}.assignedWorkerWorkInfo.attendanceTypeId` as any
                    )
                )
                .map((id, index) =>
                  id === ATTENDANCE_TYPE_PRESENT ? index : null
                )
                .filter((index) => index !== null);

              return Formatter.workingTime(
                form
                  .getValues(
                    Array(matterSize)
                      .fill(null)
                      .map(
                        (_, index) =>
                          `results.${index}.assignedWorkerWorkInfo.restTime` as any
                      )
                  )
                  .filter((value) => !TypeUtils.isNil(value))
                  .map((value) => parseInt(value.toString()))
                  .filter((value) => !TypeUtils.isNilNumber(value))
                  .reduce((prev: number, cur: number) => prev + cur, 0)
              );
            }}
          />
        </GridItem>
        <GridItem>
          <FormText
            label="総労働時間"
            name="reference.dailyWork"
            value={() => Formatter.workingTime(totalWorkTime)}
          />
        </GridItem>
      </Grid>
    );
  };

  return { DailyWork, isAbsence, toggle };
};

/**
 * 日次就業エリア
 *
 * @returns
 */
const DailyWork: React.FunctionComponent<DailyWorkProps> = ({
  matterSize,
  totalWorkTime,
  workTimeFrom,
  workTimeTo,
}) => {
  const form = useFormContext<AssignWorkInfoDaySearchResult>();
  const { FormText } = useFormItems(form);

  return (
    <Grid
      backgroundColor="white"
      borderColor="gray.300"
      borderRadius="md"
      borderWidth={1}
      padding={2}
      templateColumns="1fr 1fr"
      width="full"
    >
      <GridItem>
        <FormText
          label="開始時刻"
          name="reference.dailyWork"
          value={() => Formatter.dateTimeOfWeekString(workTimeFrom, '―')}
        />
      </GridItem>
      <GridItem>
        <FormText
          label="終了時刻"
          name="reference.dailyWork"
          value={() => Formatter.dateTimeOfWeekString(workTimeTo, '―')}
        />
      </GridItem>
      <GridItem>
        <FormText
          label="休憩時間"
          name="reference.dailyWork"
          value={() =>
            Formatter.workingTime(
              form
                .getValues(
                  Array(matterSize)
                    .fill(null)
                    .map(
                      (_, index) =>
                        `results.${index}.assignedWorkerWorkInfo.restTime` as any
                    )
                )
                .filter((value) => !TypeUtils.isNil(value))
                .map((value) => parseInt(value.toString()))
                .filter((value) => !TypeUtils.isNilNumber(value))
                .reduce((prev: number, cur: number) => prev + cur, 0)
            )
          }
        />
      </GridItem>
      <GridItem>
        <FormText
          label="総労働時間"
          name="reference.dailyWork"
          value={() => Formatter.workingTime(totalWorkTime)}
        />
      </GridItem>
    </Grid>
  );
};

export default DailyWork;
